<script lang="ts">
  import LoadingSpinner from '../loader/LoadingSpinner.svelte';

  export let variant: 'primary' | 'secondary' = 'primary';
  export let disabled: boolean = false;
  export let isLoading: boolean = false;

  const SLOTS = $$props.$$slots;
</script>

<style lang="postcss">
  button {
    display: flex;
    align-items: center;
  }

  .secondary {
    --ubilabs-button-background-color: var(
      --ubilabs-button-secondary-background-color
    );
    --ubilabs-button-hover-background-color: var(
      --ubilabs-button-secondary-hover-background-color
    );
    --ubilabs-button-active-background-color: var(
      --ubilabs-button-secondary-active-background-color
    );
    --ubilabs-button-disabled-background-color: var(
      --ubilabs-button-secondary-disabled-background-color
    );
    --ubilabs-button-label-color: var(--ubilabs-button-secondary-label-color);
    --ubilabs-button-disabled-label-color: var(
      --ubilabs-button-secondary-disabled-label-color
    );
  }

  button > :global([slot='icon']),
  button > :global(.buttonSpinner) {
    display: inline-flex;
    align-items: center;
    margin: 0 0.5em 0 -0.5em;
  }

  button > :global(.buttonSpinner) {
    border-color: var(--ubilabs-blue-light-2);
    border-top-color: var(--ubilabs-blue);
  }

  .default-slot > :global(*) {
    margin: 0 0.25rem;
  }
</style>

<button
  {...$$restProps}
  disabled={disabled || isLoading}
  class="{variant} {$$props.class}"
  on:click>
  {#if isLoading}
    <LoadingSpinner class="buttonSpinner" />
  {:else if SLOTS.icon}
    <slot name="icon" />
  {/if}
  {#if SLOTS.default}
    <span class="default-slot">
      <slot />
    </span>
  {/if}
</button>
